/**
 * @flow
 * @relayHash f039f599bb6979ae6e2fe840cbeafe27
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateMapCardInput = {
  name: string,
  thumbnailImage?: ?string,
  savedAreaId?: ?string,
  indicators?: ?$ReadOnlyArray<?MapCardIndicatorInput>,
  sectionIds?: ?$ReadOnlyArray<?string>,
  zoom?: ?number,
  center?: ?PointInput,
  addToFavorites?: ?boolean,
  addToPublicFeed?: ?boolean,
  mapImageOnly?: ?boolean,
  notes?: ?string,
  clientMutationId?: ?string,
};
export type MapCardIndicatorInput = {
  id?: ?string,
  alpha?: ?number,
  isVisible?: ?boolean,
  palette?: ?number,
  customPalette?: ?$ReadOnlyArray<?string>,
  position?: ?number,
};
export type PointInput = {
  lng?: ?number,
  lat?: ?number,
};
export type SaveMapPopupMutationVariables = {|
  input: CreateMapCardInput
|};
export type SaveMapPopupMutationResponse = {|
  +createMapCard: ?{|
    +mapCardNode: ?{|
      +id: string,
      +configuration: {|
        +title: ?string
      |},
    |}
  |}
|};
export type SaveMapPopupMutation = {|
  variables: SaveMapPopupMutationVariables,
  response: SaveMapPopupMutationResponse,
|};
*/


/*
mutation SaveMapPopupMutation(
  $input: CreateMapCardInput!
) {
  createMapCard(input: $input) {
    mapCardNode {
      id
      configuration {
        title
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateMapCardInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreateMapCardInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "SaveMapPopupMutation",
  "id": null,
  "text": "mutation SaveMapPopupMutation(\n  $input: CreateMapCardInput!\n) {\n  createMapCard(input: $input) {\n    mapCardNode {\n      id\n      configuration {\n        title\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SaveMapPopupMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createMapCard",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateMapCardPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "mapCardNode",
            "storageKey": null,
            "args": null,
            "concreteType": "BoardCardUseNode",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "configuration",
                "storageKey": null,
                "args": null,
                "concreteType": "BoardCardConfigurationNode",
                "plural": false,
                "selections": [
                  v3
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SaveMapPopupMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createMapCard",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateMapCardPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "mapCardNode",
            "storageKey": null,
            "args": null,
            "concreteType": "BoardCardUseNode",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "configuration",
                "storageKey": null,
                "args": null,
                "concreteType": "BoardCardConfigurationNode",
                "plural": false,
                "selections": [
                  v3,
                  v2
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ad61d9aa974cadb3453e4544e176db92';
module.exports = node;



// WEBPACK FOOTER //
// ./src/components/SaveMapPopup/__generated__/SaveMapPopupMutation.graphql.js